import React from 'react';
import styled, {useTheme} from "styled-components";
import VenatusAd from "../ad/VenatusAd";
import {FlexBox, MarginBox} from "../ui/styled";
import BigTooltip from "../Tooltip/BigTooltipBox";
import {Link} from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
  border-radius: 8px;
  width: 100%;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: row;
`;

const VideoWrapper = styled.div`
  width: 410px;
  height: 230px;
  background-color: #D9D9D9;
`;
const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 16px;
  flex: 1;
`;

const FilterTextWrapper = styled.div`
  width: 72px;
`;
const FilterText = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: ${props => props.theme.color.dark_200};
`;

const FilterContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const FilterButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
const FilterBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FilterBar = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.color.gray_200};
`;

const CustomClanFilterHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 20px;
  background-color: ${props => props.theme.color.white_201};
  border-bottom: 1px solid ${props => props.theme.color.default_border_color};
`;

const CustomClanFilterHeaderTitle = styled.div`
  font-weight: 500;
  font-size: 15px;
  line-height: 100%;
  text-align: center;
  color: ${props => props.theme.color.dark_100};
  margin-left: 16px;
`;


const TrackerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 1;
`;
const NavigateToTrackerButton = styled.button`
  border-radius: 100px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
  color: ${props => props.theme.color.dark_100};
  height: 34px;
  width: 143px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }
`;
const FilterSelectedText = styled.div`
  margin-right: 8px;
  font-weight: 500;
  font-size: 14px;
  color: ${props => props.theme.color.dark_100};
`;

const SelectedFilterBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 8px;
  gap: 8px;
`;
const ResetButtonBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
const CustomClanFilter = ({
                              setServerMode,
                              serverMode,
                              setPageValue,
                              search,
                              setSearch,
                              setClanModeFilter,
                              setGameModeFilter,
                              setPlayerFilter,
                              ageFilter,
                              clanModeFilter,
                              setAgeFilter,
                              gameModeFilter,
                              playerFilter
                          }) => {
    const theme = useTheme();


    const onClickFilter = ({isSelected, value, setter}) => {
        if (isSelected) {
            setter({})
        } else {
            setter(value)
        }
    }
    const onClickPlayerCountFilter = ({isSelected, value}) => {
        onClickFilter({isSelected, value, setter: setPlayerFilter})
        setPageValue(1)
    }
    const onClickGameModeFilter = ({isSelected, value}) => {
        onClickFilter({isSelected, value, setter: setGameModeFilter})
        setPageValue(1)
    }
    const onClickAgeFilter = ({isSelected, value}) => {
        onClickFilter({isSelected, value, setter: setAgeFilter})

        setPageValue(1)
    }
    const onClickClanModeFilter = ({isSelected, value}) => {
        onClickFilter({isSelected, value, setter: setClanModeFilter})
        setPageValue(1)
    }

    const onClickServerModeFilter = ({isSelected, value}) => {
        onClickFilter({isSelected, value, setter: setServerMode})
        setPageValue(1)
    }


    const onClickReset = () => {
        setPlayerFilter({})
        setClanModeFilter({})
        setGameModeFilter({})
        setAgeFilter({})
        setServerMode({})
    }


    const tooltipText = `<div style="display: flex; flex-direction: column; align-items: flex-start; ">
<div style="color: #46B9AA;font-weight: 500; width: 100%; margin-bottom: 7px; font-size: 12px; white-space: nowrap; text-align: left;">서버유형      </div>
    <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; white-space: nowrap;">
        <div style="color: #fff; font-weight: 700; font-size: 12px; width: 42px; margin-right: 12px; text-align: left;">클랜</div>
        <div style="color: #fff; font-weight: 400; font-size: 12px; text-align: right; width: 140px;">누구나 지원 가능한 공개 서버</div>
    </div>
    <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; white-space: nowrap;">
        <div style="color: #fff; font-weight: 700; font-size: 12px; width: 42px; margin-right: 12px; text-align: left;">크루</div>
        <div style="color: #fff; font-weight: 400; font-size: 12px; text-align: right; width: 140px">멤버 모집 없는 지인 전용 서버</div>
    </div>
    <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; white-space: nowrap;">
        <div style="color: #fff; font-weight: 700; font-size: 12px; width: 42px; margin-right: 12px; text-align: left;">스트리머</div>
        <div style="color: #fff; font-weight: 400; font-size: 12px; text-align: right; width: 140px;">시청자와 소통하는 방송 서버</div>
    </div>
</div>`

    return (

        <Wrapper>
            <CustomClanFilterHeader>
                <img src={`${theme.icon.path}/connect/img_connect_logo.svg`} width={144} height={32} alt={''}/>
                <CustomClanFilterHeaderTitle>
                    <span>모임·클랜·내전 전적을 자동으로 남기세요!</span>
                </CustomClanFilterHeaderTitle>
                <TrackerWrapper>
                    <Link to={'/tracker'}>
                        <NavigateToTrackerButton>
                            <div>
                                <span>자세히 알아보기</span>
                            </div>
                            <MarginBox margin={'0 0 0 8px'}>
                                <img src={`${theme.icon.path}/connect/btn_ai-score.svg`} width={18} height={18}
                                     alt={''}/>
                            </MarginBox>
                        </NavigateToTrackerButton>
                    </Link>
                </TrackerWrapper>
            </CustomClanFilterHeader>
            <ContentBox>
                <FilterWrapper>
                    <FilterBox>
                        <FlexBox height={'auto'}>
                            <ServerModeFilter playerFilter={serverMode} onClick={onClickServerModeFilter}
                                              tooltipText={tooltipText}/>
                            <ResetButtonBox>
                                <button onClick={onClickReset}>
                                    <img src={`${theme.icon.path}/connect/img_icon_rotate.svg`} alt={''} width={32}
                                         height={32}/>
                                </button>
                            </ResetButtonBox>
                        </FlexBox>
                        <MarginBox margin={'0 0 0 24px'}>
                            <PlayerCountFilter onClick={onClickPlayerCountFilter} playerFilter={playerFilter}/>
                        </MarginBox>
                        <MarginBox margin={'0 0 0 24px'}>
                            <GameModeFilter onClick={onClickGameModeFilter} gameModeFilter={gameModeFilter}/>
                        </MarginBox>
                        <MarginBox margin={'0 0 0 24px'}>
                            <GroupFilter onClick={onClickClanModeFilter} clanModeFilter={clanModeFilter}/>
                        </MarginBox>
                        <MarginBox margin={'0 0 0 24px'}>
                            <AgeFilter onClick={onClickAgeFilter} ageFilter={ageFilter}/>
                        </MarginBox>
                    </FilterBox>

                </FilterWrapper>
                <VideoWrapper>
                    <VenatusAd placementName={'video'}/>
                </VideoWrapper>
            </ContentBox>
        </Wrapper>
    );
};

const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`;


const ServerModeFilter = ({onClick, playerFilter, tooltipText}) => {
    const theme = useTheme();
    const list = [{title: '클랜', icon: 'clan_icon_shield.svg'}, {
        title: '크루',
        icon: "clan_icon_crew.svg"
    }, {title: '스트리머', icon: "clan_icon_streamer.svg"}]
    return (
        <FilterContentWrapper>
            {tooltipText ?
                <BigTooltip tooltipText={tooltipText}>
                    <TooltipWrapper>
                        <MarginBox margin={'0 4px 0 0'}>
                            <img src={`${theme.icon.path}/connect/icon_tooltip.svg`} width={20} height={20}
                                 alt={''}/>
                        </MarginBox>
                        <FilterTextWrapper>
                            <FilterText>
                                서버 유형
                            </FilterText>
                        </FilterTextWrapper>
                    </TooltipWrapper>
                </BigTooltip>
                :
                <FilterTextWrapper>
                    <FilterText>
                        서버 유형
                    </FilterText>
                </FilterTextWrapper>
            }
            <FilterButtonBox>
                {list.map((data, index) => {
                    return (
                        <FilterButton isSelected={playerFilter.title === data.title}
                                      value={{title: data.title, filter: 'player', value: index + 1}} onClick={onClick}
                                      key={data.title} noSharp={true}>
                            <FlexBox height={'auto'}>
                                <MarginBox margin={'0 4px 0 0'}>
                                    <img src={`/images/connect/${data.icon}`} width={20} height={20} alt={''}/>
                                </MarginBox>
                                <span>{data.title}</span>
                            </FlexBox>
                        </FilterButton>
                    )
                })}
            </FilterButtonBox>
        </FilterContentWrapper>
    )
}

const PlayerCountFilter = ({onClick, playerFilter}) => {
    const list = ['소규모', '중규모', '대규모']
    return (
        <FilterContentWrapper>
            <FilterTextWrapper>
                <FilterText>
                    규모
                </FilterText>
            </FilterTextWrapper>
            <FilterButtonBox>
                {list.map((data, index) => {
                    return (
                        <FilterButton isSelected={playerFilter.title === data}
                                      value={{title: data, filter: 'player', value: index + 1}} onClick={onClick}
                                      key={data}>
                            {data}
                        </FilterButton>
                    )
                })}
            </FilterButtonBox>
        </FilterContentWrapper>
    )
}

const GameModeFilter = ({onClick, gameModeFilter}) => {
    const list = ['협곡', '칼바람']
    return (
        <FilterContentWrapper>
            <FilterTextWrapper>
                <FilterText>
                    게임모드
                </FilterText>
            </FilterTextWrapper>
            <FilterButtonBox>
                {list.map((data, index) => {
                    return (
                        <FilterButton isSelected={gameModeFilter.title === data}
                                      value={{title: data, filter: 'gameMode', value: index + 1}} onClick={onClick}
                                      key={data}>
                            {data}
                        </FilterButton>
                    )
                })}
            </FilterButtonBox>
        </FilterContentWrapper>
    )
}

const GroupFilter = ({clanModeFilter, onClick}) => {
    const list = ['빡겜', '즐겜', '친목',]
    return (
        <FilterContentWrapper>
            <FilterTextWrapper>
                <FilterText>
                    모임 형태
                </FilterText>
            </FilterTextWrapper>
            <FilterButtonBox>
                {list.map((data, index) => {
                    return (
                        <FilterButton isSelected={clanModeFilter.title === data}
                                      value={{title: data, filter: 'clanMode', value: index + 1}} onClick={onClick}
                                      key={data}>
                            {data}
                        </FilterButton>
                    )
                })}
            </FilterButtonBox>
        </FilterContentWrapper>
    )
}

const AgeFilter = ({ageFilter, onClick}) => {
    const list = ['10대', '20대', '30대', '40대']
    return (
        <FilterContentWrapper>
            <FilterTextWrapper>
                <FilterText>
                    연령대
                </FilterText>
            </FilterTextWrapper>
            <FilterButtonBox>
                {list.map((data, index) => {
                    return (
                        <FilterButton isSelected={ageFilter.title === data}
                                      value={{title: data, filter: 'age', value: index + 1}} onClick={onClick}
                                      key={data}>
                            {data}
                        </FilterButton>
                    )
                })}
            </FilterButtonBox>
        </FilterContentWrapper>
    )
}

const FilterButtonWrapper = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  border-radius: 999px;
  font-weight: 600;
  padding: 0 12px;
  height: 32px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  color: ${props => props.theme.color.dark_200};

  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }

  &.selected {
    font-weight: 500;
    border-color: ${props => props.theme.color.dark_100};
    background-color: ${props => props.theme.color.site_main_color};
    color: ${props => props.theme.color.dark_100};
  }
`;
const CloseImageWrapper = styled.div`
  margin-left: 4px;
`;
const FilterButton = ({width, onClick, children, isSelected, value, noSharp}) => {
    const theme = useTheme()
    return (
        <FilterButtonWrapper width={width} onClick={() => onClick({isSelected, value})}
                             className={isSelected ? 'selected' : ""}>
            {noSharp ?
                <div>{children}</div>
                : <span># {children}</span>
            }
            {isSelected &&
                <CloseImageWrapper>
                    <img
                        src={`${theme.icon.path}/clan/close.svg`}
                        width={16}
                        height={16}
                        alt={''}
                    />
                </CloseImageWrapper>}
        </FilterButtonWrapper>
    )
}


const SelectedFilterButtonWrapper = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  border-radius: 999px;
  font-weight: 600;
  padding: 0 12px;
  height: 32px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  color: ${props => props.theme.color.dark_100};

  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }


`;

const SelectedFilterButton = ({width, onClick, children, value}) => {
    const theme = useTheme()
    return (
        <FilterButtonWrapper width={width} onClick={() => onClick({isSelected: true, value})}
        >
            <span># {children}</span>
            <CloseImageWrapper>
                <img
                    src={`${theme.icon.path}/clan/selected_close.svg`}
                    width={16}
                    height={16}
                    alt={''}
                />
            </CloseImageWrapper>
        </FilterButtonWrapper>
    )
}


export default CustomClanFilter;